// Drawer menu accordion functionality
document.addEventListener('DOMContentLoaded', function() {
  const accordionSelectors = {
    accordion: '[drawer-menu-accordion]',
    accordionContent: '[drawer-menu-accordion-content]'
  };

  function handleAccordion(e) {
    e.preventDefault();
    const button = e.currentTarget;
    const content = button.nextElementSibling;
    const isExpanded = button.getAttribute('aria-expanded') === 'true';

    // Close all other accordions at the same level
    const parentList = button.closest('ul');
    parentList.querySelectorAll(accordionSelectors.accordion).forEach(otherButton => {
      if (otherButton !== button) {
        otherButton.setAttribute('aria-expanded', 'false');
        otherButton.nextElementSibling.setAttribute('aria-hidden', 'true');
        otherButton.nextElementSibling.style.maxHeight = '0';
      }
    });

    // Toggle current accordion
    button.setAttribute('aria-expanded', !isExpanded);
    content.setAttribute('aria-hidden', isExpanded);
    content.style.maxHeight = isExpanded ? '0' : content.scrollHeight + 'px';
   
  }

  // Initialize accordion functionality
  const drawerMenu = document.querySelector('[drawer-menu]');
  if (drawerMenu) {
    const accordionButtons = drawerMenu.querySelectorAll(accordionSelectors.accordion);
    accordionButtons.forEach(button => {
      button.addEventListener('click', handleAccordion);
    });    
  }

  // Add event listener for nav__burger--open
    document.addEventListener('click', function(e) {
      if (e.target.closest('.nav__burger--open')) {
        // Remove visible class from all submenu ul elements
        const submenuLists = document.querySelectorAll('.drawerMenu__list--sub');
        submenuLists.forEach(list => {
          list.classList.remove('visible');
          // Also reset aria-expanded on parent buttons
          const prevButton = list.previousElementSibling;
          if (prevButton) {
            prevButton.setAttribute('aria-expanded', 'false');
          }
        });
      }
    });
  // Style primary menu when submenu is open
    const observer = new MutationObserver(function(mutations) {
      const primaryMenu = document.querySelector('.drawerMenu__list--primary');
      if (primaryMenu) {
        const hasOpenSubmenu = primaryMenu.querySelector('.visible');
        if (hasOpenSubmenu) {
          primaryMenu.style.transform = 'translateX(-100%)';
        } else {
          primaryMenu.style.transform = '';
        }
      }
    });

    // Start observing the primary menu for changes
    const primaryMenu = document.querySelector('.drawerMenu__list--primary');
    if (primaryMenu) {
      observer.observe(primaryMenu, {
        attributes: true,
        childList: true,
        subtree: true
      });
    }
}); 